// update admonition padding
const admonition = document.querySelector('.enos-doc .enos-doc-content .rst-content .admonition');
if (admonition) {
  admonition.style.padding = '24px 28px 22px 28px';
}

const h1 = document.querySelectorAll('.enos-doc .enos-doc-content .rst-content h1');
const h2 = document.querySelectorAll('.enos-doc .enos-doc-content .rst-content h2');
const h3 = document.querySelectorAll('.enos-doc .enos-doc-content .rst-content h3');
const h4 = document.querySelectorAll('.enos-doc .enos-doc-content .rst-content h4');
const h5 = document.querySelectorAll('.enos-doc .enos-doc-content .rst-content h5');
const h6 = document.querySelectorAll('.enos-doc .enos-doc-content .rst-content h6');
const titleList = [h1, h2, h3, h4, h5, h6];
const fontSize = ['28px', '24px', '22px', '20px', '18px', '16px'];
titleList.forEach((item, index) => {
  if (item) {
    item.forEach((i) => {
      if (i) {
        i.style.fontSize = fontSize[index];
      }
    });
  }
});
const table = document.querySelectorAll('.enos-doc .enos-doc-content .rst-content table');
table.forEach((item) => {
  if (item) {
    item.style.minWidth = 'unset';
  }
});

const tdth = document.querySelectorAll('.enos-doc .enos-doc-content .rst-content td, .enos-doc .enos-doc-content .rst-content th');
tdth.forEach((item) => {
  if (item) {
    item.style.minWidth = '110px';
  }
});

const hlErr = document.querySelectorAll('.enos-doc .enos-doc-content .rst-content .highlight .err');
console.log('找到的 .highlight .err 元素数量:', hlErr.length);

hlErr.forEach((item) => {
  if (item) {
    item.style.setProperty('border', 'none', 'important');
  }
});
